import React, { useState, useRef, useEffect, useCallback } from "react";
import resumeData from "../components/ResumeData";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "../css/AtsprofessionalResumeEditor.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Navbar/Footer";
import ReactGA from 'react-ga4';
import menuIcon from "../images/logo.png";
import menuIcon1 from "../images/logo1.jpeg";
const A4_HEIGHT_PX = 842; // correct preview height
const useGA = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (!GA_MEASUREMENT_ID) {
      console.warn("GA_MEASUREMENT_ID is not defined");
      return;
    }

    ReactGA.initialize(GA_MEASUREMENT_ID);
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });
  }, []);
};
const AtsprofessionalResumeEditor = () => {
  const templateId = "atsprofessional";
  const template = resumeData[templateId];
  useGA();
  const [showPreview, setShowPreview] = useState(false);
const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);


  const [common, setCommon] = useState({ ...template.common,
    contact: template.common.contact || {
    email: "",
    phone: "",
    linkedin: "",
    github: "",
  },
  skills: template.common.skills || [],});
  const [experience, setExperience] = useState([...template.experience || []]);
  const [education, setEducation] = useState([...template.education || []]);
  const [projects, setProjects] = useState([...template.projects || []]);
  const [certifications, setCertifications] = useState([...template.certifications || []]);
  const [achievements, setAchievements] = useState([...template.achievements || []]);
    const [languages, setLanguages] = useState([...template.languages || []]);
  const resumeRef = useRef(null);
  const measureRef = useRef(null);
  const [pages, setPages] = useState([]);

  // =========================
  // PAGE SPLIT
  // =========================
const PAGE_PADDING = 56;   // 28 top + 28 bottom
const SAFE_BUFFER = 40;    // ⭐ increased for safety

const USABLE_PAGE_HEIGHT =
  A4_HEIGHT_PX - PAGE_PADDING - SAFE_BUFFER;
const splitIntoPages = useCallback((container) => {
  if (!container) return [];

  const sections = Array.from(
    container.querySelectorAll(".atsprofessional_header-block, .atsprofessional_section-block")
  );

  const pages = [];
  let currentPage = [];
  let currentHeight = 0;

  sections.forEach((section) => {
    const height = Math.ceil(section.offsetHeight);

    if (height >= USABLE_PAGE_HEIGHT) {
      if (currentPage.length) {
        pages.push([...currentPage]);
        currentPage = [];
        currentHeight = 0;
      }

      pages.push([section]);
      return;
    }

    if (currentHeight + height > USABLE_PAGE_HEIGHT) {
      pages.push([...currentPage]);
      currentPage = [];
      currentHeight = 0;
    }

    currentPage.push(section);
    currentHeight += height;
  });

  if (currentPage.length) pages.push(currentPage);
  if (!pages.length && sections.length) pages.push(sections);

  return pages;
}, [USABLE_PAGE_HEIGHT]);

useEffect(() => {
  if (!measureRef.current) return;

  const calculatePages = () => {
    const calculated = splitIntoPages(measureRef.current);
    setPages(calculated);
  };

  const raf = requestAnimationFrame(calculatePages);

  return () => cancelAnimationFrame(raf);
}, [
  common,
  experience,
  education,
  projects,
   achievements,
  languages,
  certifications,
  showPreview ,splitIntoPages  // ⭐ IMPORTANT
]);
useEffect(() => {
  const saved = localStorage.getItem("resumeData");
  if (saved) {
    const data = JSON.parse(saved);
    setCommon(data.common);
    setExperience(data.experience || []);
    setEducation(data.education);
    setProjects(data.projects);
    setCertifications(data.certifications);
    setAchievements(data.achievements);
    setLanguages(data.languages);
  }
}, []);

  // =========================
  // PDF DOWNLOAD
  // =========================
   const handleDownload = async () => {
    if (!resumeRef.current) return;
  
    const pages = resumeRef.current.querySelectorAll(".atsprofesional_pdf-page");
  
    const pdf = new jsPDF("p", "mm", "a4");
  
    for (let i = 0; i < pages.length; i++) {
  
      const canvas = await html2canvas(pages[i], {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff"
      });
  
      const imgData = canvas.toDataURL("image/png");
  
      const imgWidth = 210; // A4 width in mm
      const imgHeight = 297; // A4 height in mm
  
      if (i > 0) {
        pdf.addPage();
      }
  
      pdf.addImage(
        imgData,
        "PNG",
        0,
        0,
        imgWidth,
        imgHeight
      );
    }
  
    pdf.save(`${common.name || "Resume"}_Resume.pdf`);

    ReactGA.event({
    category: "Resume",
    action: "Download PDF",
    label: `${common.name || "Unknown"}_Resume.pdf`
  });
  };
  // =========================
  // HELPERS
  // =========================
  const updateArrayField = (array, setArray, index, field, value) => {
    const updated = [...array];
    updated[index][field] = value;
    setArray(updated);
  };

  const addNewField = (setArray, defaultObj) => {
    setArray((prev) => [...prev, defaultObj]);
  };

  const deleteArrayItem = (array, setArray, index) => {
    setArray(array.filter((_, i) => i !== index));
  };
  
  // =========================
  // CONTENT
  // =========================
  const ResumeInner = () => (
    <>
      <div className="atsprofessional_header-block">
        <div className="atsprofessional_name">
      <h1 className="headingcareer">{common.name}</h1>
      <h2 className="subheadingcareer">{common.title}</h2></div>
        <div className="contact">
        <p style={{color:"#201202"}}>📨 {common.contact?.email}</p><p style={{color:"#201202"}}>📱 {common.contact?.phone}</p>
        <p style={{color:"#201202"}}>💼 {common.contact?.linkedin} </p><p style={{color:"#201202"}}>🐙 {common.contact?.github}</p>
      </div>
    </div>

      {common.summary && (
        <section className="atsprofessional_section-block">
          <h3 className="atsprofessional_section-headingcareer">Professional Summary</h3>
          <p className="atsprofessional_summary">{common.summary}</p>
        </section>
      )}

      {common.skills?.length > 0 && (
      <section className="atsprofessional_section-block">
        <h3 className="atsprofessional_section-headingcareer">Skills</h3>
        <ul className="atsprofessional_listcareer">
        {common.skills.map((skill, idx) => (
            <div key={idx} className="pdf-section1">
              <li className="atsprofessional_skill-gapcareer"> <div>{skill}</div></li>
            </div>
          ))}</ul>
      </section>
    )}

    {education?.length > 0 && (
        <section className="atsprofessional_section-block">
          <h3 className="atsprofessional_section-headingcareer">Education</h3>
          <div className="ed1">
              <div className="deg1">
              <strong>Degree</strong> </div> 
              <div className="ins1intern"><strong>institution</strong></div> 
              <div className="year1intern"><strong> Passed Out Year</strong></div>
            </div>
          {education.map((edu, idx) => (
            <div key={idx} className="pdf-sectionintern">
              <div className="ed" style={{fontSize:"14px"}}>
              <div className="deg">
              {edu.degree} </div> 
              <div className="ins">{edu.institution}</div> 
              <div className="year"> ({edu.year})</div>
            </div></div>
          ))}
        </section>
      )}

      {experience?.length > 0 && (
  <section className="atsprofessional_section-block">
    <h3 className="atsprofessional_section-headingcareer">Professional Experience</h3>
    {experience.map((item, idx) => (
      <div key={idx} className="pdf-sectionintern" style={{fontSize:"12px"}}>
        <strong>{item.role}</strong> @ {item.company} ({item.duration})
        <p>{item.desc}</p>
      </div>
    ))}
  </section>
)}

      {projects?.length > 0 && (
        <section className="atsprofessional_section-block">
          <h3 className="atsprofessional_section-headingcareer">Projects</h3>
          {projects.map((proj, idx) => (
            <div key={idx} className="pdf-sectionintern" style={{fontSize:"12px"}}>
              <strong>{proj.title}</strong>
              <p>{proj.desc}</p>
            </div>
          ))}
        </section>
      )}

      {certifications?.length > 0 && (
        <section className="atsprofessional_section-block">
          <h3 className="atsprofessional_section-headingcareer">Certifications</h3>
          {certifications.map((cert, idx) => (
            <div key={idx} className="pdf-sectionintern" style={{fontSize:"12px"}}>
              -{cert.name}
            </div>
          ))}
        </section>
      )}
      {achievements?.length > 0 && (
      <section className="atsprofessional_section-block">
        <h3 className="atsprofessional_section-headingcareer">Achievements</h3>
        <ul className="listcareer">
        {achievements.map((skill, idx) => (
            <div key={idx} className="pdf-section1" style={{fontSize:"12px"}}>
              <li className="skill-gapcareer"> <div>{skill}</div></li>
            </div>
          ))}</ul>
      </section>
    )}
    {languages?.length > 0 && (
      <section className="atsprofessional_section-block">
        <h3 className="atsprofessional_section-headingcareer">Languages</h3>
        <ul className="listcareer">
        {languages.map((skill, idx) => (
            <div key={idx} className="pdf-section1" style={{fontSize:"12px"}}>
              <li className="skill-gapcareer"> <div>{skill}</div></li>
            </div>
          ))}</ul>
      </section>
    )}
    </>
  );
const handleCreatePortfolio = () => {

  const portfolioData = {
    common,
    experience,
    education,
    projects,
    certifications,
    languages,
    achievements,
  };

  const username = common.name
    ?.toLowerCase()
    .replace(/\s+/g, "");

  const uniqueId = Math.random().toString(36).substring(2,8);
  const portfolioId = username + "-" + uniqueId;

  localStorage.setItem(
    "portfolio_" + portfolioId,
    JSON.stringify(portfolioData)
  );

  window.open(`/portfolio/atsprofessional/${portfolioId}`, "_blank");
};
  // =========================
  // JSX
  // =========================
  return (
    <><Navbar />
    <div className="app-container">
      <div className="editor-container"><div>
        {(!isMobile || !showPreview) && (
        <div className="editor-sidebar">
          <h2 style={{fontSize:"18px"}}>Ats Friendly Professional Resume Editor</h2>

          <label>Full Name</label>
          <input
            value={common.name}
            onChange={(e) =>
              setCommon({ ...common, name: e.target.value })
            }
          />

          <label>Title</label>
          <input
            value={common.title}
            onChange={(e) =>
              setCommon({ ...common, title: e.target.value })
            }
          />
          <h3>Contact Details</h3>

<label>Email</label>
<input
  value={common.contact?.email || ""}
  onChange={(e) =>
    setCommon({
      ...common,
      contact: { ...common.contact, email: e.target.value },
    })
  }
/>

<label>Phone</label>
<input
  value={common.contact?.phone || ""}
  onChange={(e) =>
    setCommon({
      ...common,
      contact: { ...common.contact, phone: e.target.value },
    })
  }
/>

<label>LinkedIn</label>
<input
  value={common.contact?.linkedin || ""}
  onChange={(e) =>
    setCommon({
      ...common,
      contact: { ...common.contact, linkedin: e.target.value },
    })
  }
/>

<label>GitHub</label>
<input
  value={common.contact?.github || ""}
  onChange={(e) =>
    setCommon({
      ...common,
      contact: { ...common.contact, github: e.target.value },
    })
  }
/>

          <label>Professional Summary</label>
          <textarea
            value={common.summary}
            onChange={(e) =>
              setCommon({ ...common, summary: e.target.value })
            }
          />

          <h3>Skills</h3>
<div className="skillsfield">
{common.skills?.map((skill, idx) => (
  <div key={idx} className="dynamic-field1">
    <div>
    <input
      placeholder="Skill"
      value={skill} className="input1"
      onChange={(e) => {
        const updated = [...common.skills];
        updated[idx] = e.target.value;
        setCommon({ ...common, skills: updated });
      }}
    /><br></br>
    <button
      className="delete-btn1"
      onClick={() => {
        const updated = common.skills.filter((_, i) => i !== idx);
        setCommon({ ...common, skills: updated });
      }}
    >
      Delete
    </button></div>
  </div>
))}</div>

<button
  className="add"
  onClick={() =>
    setCommon({
      ...common,
      skills: [...(common.skills || []), ""],
    })
  }
>
  + Add Skill
</button>
          
          <h3>Professional Experience</h3>
{experience.map((item, idx) => (
  <div key={idx} className="dynamic-field">
    <input
      placeholder="Role"
      value={item.role}
      onChange={e =>
        updateArrayField(experience, setExperience, idx, "role", e.target.value)
      }
    />
    <input
      placeholder="Company"
      value={item.company}
      onChange={e =>
        updateArrayField(experience, setExperience, idx, "company", e.target.value)
      }
    />
    <input
      placeholder="Duration"
      value={item.duration}
      onChange={e =>
        updateArrayField(experience, setExperience, idx, "duration", e.target.value)
      }
    />
    <textarea
      placeholder="Description"
      value={item.desc}
      onChange={e =>
        updateArrayField(experience, setExperience, idx, "desc", e.target.value)
      }
    />
    <button
      className="delete-btn"
      onClick={() => deleteArrayItem(experience, setExperience, idx)}
    >
      Delete
    </button>
  </div>
))}

<button
  className="add"
  onClick={() =>
    addNewField(setExperience, {
  role: "",
  company: "",
  duration: "",
  desc: ""
})
  }
>
  + Add Internship
</button>


              {/* Education */} 
              <h3>Education</h3> 
              {education.map((edu, idx) => ( 
                <div key={idx} className="dynamic-field"> 
                <input placeholder="Degree" value={edu.degree} 
                onChange={e => updateArrayField(education, setEducation, idx, "degree", e.target.value)} /> 
                <input placeholder="Institution" value={edu.institution} 
                onChange={e => updateArrayField(education, setEducation, idx, "institution", e.target.value)} /> 
                <input placeholder="Year" value={edu.year} 
                onChange={e => updateArrayField(education, setEducation, idx, "year", e.target.value)} /> 
                <button className="delete-btn" 
                onClick={() => deleteArrayItem(education, setEducation, idx)}>Delete</button> </div> ))} 
                <button className="add" onClick={() => addNewField(setEducation, { degree: "", institution: "", year: "" })}>+ Add Education</button> 
                {/* Projects */} 
                <h3>Projects</h3> 
                {projects.map((proj, idx) => ( 
                  <div key={idx} className="dynamic-field"> 
                  <input placeholder="Project Title" value={proj.title} 
                  onChange={e => updateArrayField(projects, setProjects, idx, "title", e.target.value)} /> 
                  <textarea placeholder="Description" value={proj.desc} 
                  onChange={e => updateArrayField(projects, setProjects, idx, "desc", e.target.value)} /> 
                  <button className="delete-btn" onClick={() => deleteArrayItem(projects, setProjects, idx)}>Delete</button> </div> ))} 
                  <button className="add" onClick={() => addNewField(setProjects, { title: "", desc: "" })}>+ Add Project</button> 
                  {/* Certifications */} 
                  <h3>Certifications</h3> 
                  {certifications.map((cert, idx) => ( 
                    <div key={idx} className="dynamic-field"> 
                    <input placeholder="Certification" value={cert.name || ""} 
                    onChange={e => updateArrayField(certifications, setCertifications, idx, "name", e.target.value)} /> 
                    <button className="delete-btn" 
                    onClick={() => deleteArrayItem(certifications, setCertifications, idx)}>Delete</button> 
                    </div> ))} 
                    <button className="add" onClick={() => addNewField(setCertifications, { name: "" })}>+ Add Certification</button>

          {!isMobile && (
            <>
<button className="download-btn no-print" onClick={handleDownload}>
Download PDF
</button>
<button className="download-btn" onClick={handleCreatePortfolio}>
Create Portfolio Link
</button></>
)}
          {isMobile && (
  <button
    className="download-btn no-print"
    onClick={() => setShowPreview(true)}
  >
    Preview Resume
  </button>
)}

        </div>)}
        {(!isMobile || !showPreview) && (
  <>
        <div className="template-info-section">
  <h2>About This Resume Template</h2>

  <div className="template-info-grid">

    <div className="info-card">
      <h3>Template Name</h3>
      <p>ATS Professional Resume</p>
    </div>

    <div className="info-card">
  <h3>Created By</h3><div style={{display:"flex"}}>
  <img src={menuIcon} alt="menu" style={{height:"50px",width:"50px"}}/>
  <p>@ElevateMe</p></div>
</div>

<div className="info-card">
  <h3>Template Author</h3>
  <p>Designed by <div style={{display:"flex",paddingLeft:"20px"}}>
  <img src={menuIcon1} alt="menu" style={{height:"50px",width:"50px",borderRadius:"20px"}}/>
   <a
            href="https://yaganti-spandana.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
            style={{color:"rgb(26, 116, 206)",marginTop:"15px"}}
          >
            SPANDANA YAGANTI
          </a></div> for students and job seekers.</p>
</div>

    <div className="info-card">
      <h3>Version</h3>
      <p>Version 1.0</p>
    </div>

    <div className="info-card">
      <h3>Template Language</h3>
      <p>English</p>
    </div>

    <div className="info-card">
      <h3>Category</h3>
      <p>Professional / Experienced / Corporate</p>
    </div>

    <div className="info-card">
      <h3>Best For</h3>
      <p>
        Experienced Professionals, Mid-Level Roles,
        Senior Engineers, Corporate Applications
      </p>
    </div>

    <div className="info-card">
      <h3>Design Style</h3>
      <p>ATS Optimized, Professional, Clean Layout</p>
    </div>

    <div className="info-card">
      <h3>ATS Friendly</h3>
      <p>Yes ✓ Optimized for Applicant Tracking Systems</p>
    </div>

    <div className="info-card">
      <h3>Sections Included</h3>
      <p>
        Profile, Contact, Summary, Skills, Education,
        Experience, Projects, Certifications,
        Achievements, Languages
      </p>
    </div>

    <div className="info-card">
      <h3>Page Format</h3>
      <p>A4 • One Page / Multi Page Support</p>
    </div>

    <div className="info-card">
      <h3>Download Format</h3>
      <p>PDF Export Available</p>
    </div>

    <div className="info-card">
      <h3>Customization</h3>
      <p>
        Edit content, add sections,
        update achievements, create portfolio link
      </p>
    </div>

    <div className="info-card">
      <h3>Ideal Roles</h3>
      <p>
        Software Engineer, Data Analyst,
        Product Manager, Business Analyst,
        Team Lead
      </p>
    </div>

    <div className="info-card">
      <h3>Portfolio Builder</h3>
      <p>
        Create a personal portfolio website instantly
        from your resume data.
      </p>
    </div>

    <div className="info-card">
      <h3>Portfolio Features</h3>
      <p>
        Showcase projects, skills, education,
        achievements, and work experience.
      </p>
    </div>

    <div className="info-card">
      <h3>Share Portfolio</h3>
      <p>
        Generate a unique portfolio link
        for recruiters and companies.
      </p>
    </div>

    <div className="info-card">
      <h3>Portfolio URL</h3>
      <p>
        Auto-generated personalized portfolio link.
      </p>
    </div>

    <div className="info-card">
      <h3>Recruiter Benefits</h3>
      <p>
        Recruiters can review technical skills,
        experience, projects, and achievements
        in one place.
      </p>
    </div>

    <div className="info-card">
      <h3>Portfolio Compatibility</h3>
      <p>
        Mobile Friendly • Desktop Friendly • Shareable Anywhere
      </p>
    </div>

    <div className="info-card">
      <h3>Professional Features</h3>
      <p>
        Supports achievements, certifications,
        languages, and multi-role experience.
      </p>
    </div>

    <div className="info-card">
      <h3>Industry Usage</h3>
      <p>
        IT, Finance, Consulting, Marketing,
        Product, Operations
      </p>
    </div>

    <div className="info-card">
      <h3>Last Updated</h3>
      <p>May 2026</p>
    </div>

    <div className="info-card">
      <h3>Tags</h3>
      <p>
        ATS Resume, Professional Resume,
        Corporate Resume, Experienced Resume
      </p>
    </div>

  </div>
</div></>
)}</div>
        {(!isMobile || (isMobile && showPreview)) && (
<div className="editor-preview-wrapper">
{/* hidden measure */}
<div className="resume-measure" ref={measureRef}>
<div className="atsprofesional_resume-content">
<ResumeInner />
</div>
</div>

{/* preview pages */}

<div className="resume-pages" ref={resumeRef}>

{pages.length === 0 ? (
<div style={{padding:"20px"}}>Loading preview...</div>
) : (
pages.map((pageSections,pageIndex)=>(
<div key={pageIndex} className="atsprofesional_pdf-page">

<div className="atsprofesional_resume-content">
{pageSections.map((section,idx)=>(
<div
key={idx}
dangerouslySetInnerHTML={{
__html:section.outerHTML
}}
/>
))}
</div>

</div>
))
)}


<br></br>
{isMobile && (
<>
<button
className="download-btn"
style={{marginTop: "2px", width: "100%", padding: "12px,", backgroundColor:  "#1d4ed8", color: "white", border: "none", borderRadius: "30px",height:"30px", cursor: "pointer", fontWeight: "600", transition: "0.2s"}}
onClick={handleDownload}
>
Download PDF
</button>
<button className="download-btn" 
style={{marginTop: "2px", width: "100%", padding: "12px,", backgroundColor:  "#1d4ed8", color: "white", border: "none", borderRadius: "30px",height:"30px", cursor: "pointer", fontWeight: "600", transition: "0.2s"}}
onClick={handleCreatePortfolio}>
Create Portfolio Link
</button>

<button
className="download-btn"
style={{marginTop: "2px", width: "90%", padding: "12px,", backgroundColor:  "#1d4ed8", color: "white", border: "none", borderRadius: "30px",height:"30px", cursor: "pointer", fontWeight: "600", transition: "0.2s"}}
onClick={()=>setShowPreview(false)}
>
Back To Editor
</button>
</>
)}
</div>
</div>

)}

      </div>
    </div><Footer /></>
  );
};

export default AtsprofessionalResumeEditor;